import Model from '../Model'

export default class StreamReport extends Model {
    // Set the resource route of the model
    resource() {
        return 'admin/stream-reports'
    }
}
